import React from 'react';
import { LeftOutlined } from '@ant-design/icons';
import { Trans } from 'react-i18next';
import s from '../Login.module.scss';
const LoginMethodWithTitle = ({ children, title, icon, description, onBack }) => (React.createElement("div", { className: s.loginMethodWrapper },
    onBack && (React.createElement("button", { onClick: onBack, className: s.backButton },
        React.createElement(LeftOutlined, null),
        React.createElement("span", null,
            React.createElement(Trans, { i18nKey: "goBack" })))),
    icon && (React.createElement("div", { className: s.loginMethodIcon },
        React.createElement("img", { src: icon, alt: "" }))),
    React.createElement("div", { className: s.loginMethodTitleBlock },
        React.createElement("h3", { className: s.loginMethodTitle }, title),
        description && React.createElement("p", { className: s.loginMethodDescription }, description)),
    children));
export default LoginMethodWithTitle;
